import { DatePicker } from 'antd';
import { ReactComponent as IconCalendar } from 'asserts/icons/ic_calendar_lined.svg';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import dayjs from 'dayjs';

interface DatePickerInputProps {
  placeholder: string;
  value: string | null;
  onChange: (e: any, s: any) => void;
  endPicker?: boolean;
  limitDate?: string | null;
}

const DatePickerInput = ({
  placeholder,
  value,
  onChange,
  endPicker,
  limitDate
}: DatePickerInputProps) => {
  return (
    <Wrapper>
      <DatePicker
        onChange={onChange}
        suffixIcon={<IconCalendar />}
        placeholder={placeholder}
        value={value !== '' ? dayjs(value) : ''}
        allowClear={false}
        disabled={endPicker && !limitDate ? true : false}
        disabledDate={(current) => {
          if (endPicker && limitDate) {
            return current && current < dayjs(limitDate, 'YYYY-MM-DD').startOf('day');
          }
          return false;
        }}
      />
    </Wrapper>
  );
};

export default DatePickerInput;

const Wrapper = styled.div`
  .ant-picker {
    width: 180px;
    height: 34px;
    background: ${color.opacityWhite01};
    border: none;

    .ant-picker-input {
      input {
        &::placeholder {
          ${font.caption1_regular};
        }
      }
      .ant-picker-clear {
        svg {
          fill: ${color.white};
        }
      }
    }
  }
`;
